<template>
  <router-link v-if="routerLink" :to="href" class="btn-primary">
    <span>
        <slot></slot>
    </span>
  </router-link>

  <a v-else :href="href" class="btn-primary">
    <span>
        <slot></slot>
    </span>
  </a>
</template>

<script>
export default {
    props: {
        href: {
            type: String,
            default: ''
        },
        routerLink: {
          type: Boolean,
          default: false
        }
    }
}
</script>